import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { getShow as show } from '../../lib/show';

const Container = styled.div`
  padding: ${(props) =>
    `${props.theme.whitespace.base} ${props.theme.whitespace.xl}`};
  display: flex;
  align-content: center;
  background: ${(props) => props.theme.colours.primary};
  color: white;
`;

const InnerContainer = styled.div`
  max-width:1024px;
  margin: auto;
  display: flex;
  align-content: center;
  height: 100%;
  width: calc(100% - 65px);`;

const Brand = styled.div`
  height: 30px;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  background-image: url(${(props) =>
    _.get(props.theme, 'assets.brand', 'none')});
  background-position: center center;
  cursor: pointer;
`;

const Logout = styled.div`
  font-size: 20px;
  color: white;
`;

const LogoutA = styled.a`
  font-size: 17px;
  color: white !important;
`;

const AppHeader = ({ history, session }) => {

  const showLogout = show('logout',true);

  const LogoutLink =
    !session || !session.token || !showLogout
      ? () => ''
      : () => (
        <Logout className="logout">
          <LogoutA href="/logout">Log out</LogoutA>
        </Logout>
        );

  return (
    <Container className="app-header">
      <InnerContainer>
        <Brand className="brand" onClick={() => history.push('/products/')} />
        <LogoutLink className="logout" />
      </InnerContainer>
    </Container>
  );
};
AppHeader.defaultProps = {
  session: undefined
};
AppHeader.propTypes = {
  session: PropTypes.shape({
    token: PropTypes.string
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default withRouter(AppHeader);
